import {AxiosWrapper} from "../utils/axios.wrapper";
import {FeaturesLoaded} from "../actions/user.actions";

export class PataflagService {
    private static _featureFlags: any = {};
    private static _remoteConfigs: any = {};

    static setFeatures(features: any) {
        if (features?.evaluation?.featureFlags) {
            this._featureFlags = features.evaluation.featureFlags;
        }
        if (features?.evaluation?.remoteConfigs) {
            this._remoteConfigs = features.evaluation.remoteConfigs;
        }
    }

    static flag(featureName: string): boolean {
        return this._featureFlags[featureName] ?? false;
    }

    static valueOf(configName: string): any {
        return this._remoteConfigs[configName];
    }

    static getInstance() {
        return {
            flag: (featureName: string) => this.flag(featureName),
            valueOf: (configName: string) => this.valueOf(configName)
        };
    }

    static async fetchFlagsInitialize(): Promise<FeaturesLoaded> {
        const response = await AxiosWrapper.get('/api/FFlags/Initialize');
        return new FeaturesLoaded(response.data);
    }
}
